/**
 * Checks whether obj matches the FeatureDracoExtension interface
 * @param obj
 */
export function isFeatureDracoExtension(obj) {
    if (typeof obj !== "object")
        return false;
    if (obj === null)
        return false;
    if (typeof obj.byteOffset !== "number")
        return false;
    if (typeof obj.byteLength !== "number")
        return false;
    if (typeof obj.properties !== "object" || obj.properties === null)
        return false;
    if (typeof obj.properties.POSITION !== "undefined" && typeof obj.properties.POSITION !== "number")
        return false;
    if (typeof obj.properties.RGB !== "undefined" && typeof obj.properties.RGB !== "number")
        return false;
    if (typeof obj.properties.RGBA !== "undefined" && typeof obj.properties.RGBA !== "number")
        return false;
    if (typeof obj.properties.NORMAL !== "undefined" && typeof obj.properties.NORMAL !== "number")
        return false;
    if (typeof obj.properties.BATCH_ID !== "undefined" && typeof obj.properties.BATCH_ID !== "number")
        return false;
    return true;
}
/**
 * Checks whether obj matches the FeatureDracoExtension interface
 * @param obj
 */
export function isBatchDracoExtension(obj) {
    if (typeof obj !== "object")
        return false;
    if (obj === null)
        return false;
    if (typeof obj.properties !== "object" || obj.properties === null)
        return false;
    for (const v of Object.values(obj.properties)) {
        if (typeof v !== "number")
            return false;
    }
    return true;
}
